// @ts-nocheck
import { connect } from 'react-redux';
import AddBankForm from '../add-bank-form';
import l from '../../../../../lang';
import { addBankAccount } from '../../../../../store/bank-accounts/actions';

const AddBankAccount = ({ addBankAccount }) => {
  const handleSubmit = valuesToSend => {
    delete valuesToSend.bankAccountConfirm;
    addBankAccount(valuesToSend);
  };

  return <AddBankForm submitLabel={l('bankAccounts.addBankAccount')} handleSubmit={handleSubmit}></AddBankForm>;
};

const mapStateToProps = state => ({
  country: state.dashboard.merchantMe?.country,
  isCompany: state.dashboard.merchantMe?.company,
  newBankAccount: state.bankAccounts.newBankAccount,
  areBankAccountsAdded: !!state.bankAccounts.allBankAccounts?.data?.length,
  missingDocuments: state.companyInformation.missingDocuments,
});

const mapDispatchToProps = dispatch => ({
  addBankAccount: values => dispatch(addBankAccount(values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddBankAccount);
